import { ref } from "vue";
import { defineStore } from "pinia";
export var useValuationPlaceStore = defineStore("valuationPlaceStoreId", function () {
  /* The valuation address of the place. It may happen that it takes time to be retrieved because we call it uses google autocomplete API */
  var valuationAddressLoading = ref(false);
  var valuationPlace = ref(null);
  return {
    valuationAddressLoading: valuationAddressLoading,
    valuationPlace: valuationPlace
  };
});